import { createContext, useContext } from 'react';
import { apiClient } from '@src/api/client';

export const useConfiguration = () => {
  return apiClient.useQuery('get', '/api/config');
};

export interface ConfigurationContextValue {
  configuration: ReturnType<typeof useConfiguration>['data'];
  isLoading: boolean;
}

export const ConfigurationContext = createContext<
  ConfigurationContextValue | undefined
>(undefined);

export const useConfigurationContext = () => {
  const context = useContext(ConfigurationContext);
  if (!context) {
    throw new Error(
      'useConfigurationContext must be used within a ConfigurationProvider',
    );
  }
  return context;
};
